// extracted by mini-css-extract-plugin
module.exports = {"bb-quote-simple":"bb-quote-simple__FbLNj"};